import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "modular-wireframe-generator",
  title: "Modular Wireframe Generator",
  description:
    "Compose modular website wireframes, cycle section variations, and export layouts for design planning.",
  category: "Design",
} satisfies ToolMeta;
